import React from 'react';
import { 
  FaMapMarkerAlt, 
  FaTruck, 
  FaUser, 
  FaBox,
  FaCalendar 
} from 'react-icons/fa';
import Container from './styles';

const OrderListItem = ({ order, onClick }) => {
  const getStatusColor = (status) => {
    const colors = {
      pending: '#FFA726',
      assigned: '#42A5F5',
      picked_up: '#7E57C2',
      in_transit: '#66BB6A',
      delivered: '#4CAF50',
      cancelled: '#EF5350',
    };
    return colors[status] || '#9E9E9E';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatStatus = (status) => {
    return status?.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ') || 'Unknown';
  };

  return (
    <Container onClick={onClick} statusColor={getStatusColor(order.status)}>
      <div className="order--header">
        <div className="tracking--info">
          <FaBox className="box-icon" />
          <div>
            <h3 className="tracking--number">{order.trackingNumber || order.tracking_number}</h3>
            <p className="customer--name">
              <FaUser className="small-icon" />
              {order.customerName || order.customer_name}
            </p>
          </div>
        </div>
        <div className="status--badge" style={{ background: getStatusColor(order.status) }}>
          {formatStatus(order.status)}
        </div>
      </div>

      <div className="order--details">
        <div className="detail--row">
          <FaMapMarkerAlt className="icon pickup" />
          <div className="detail--content">
            <span className="label">Pickup</span>
            <span className="value">{order.pickupAddress || order.pickup_address || 'N/A'}</span>
          </div>
        </div>

        <div className="detail--row">
          <FaMapMarkerAlt className="icon delivery" />
          <div className="detail--content">
            <span className="label">Delivery</span>
            <span className="value">{order.deliveryAddress || order.delivery_address || 'N/A'}</span>
          </div>
        </div>

        {(order.assignedRiderName || order.assigned_rider_name) && (
          <div className="detail--row">
            <FaTruck className="icon" />
            <div className="detail--content">
              <span className="label">Rider</span>
              <span className="value">{order.assignedRiderName || order.assigned_rider_name}</span>
            </div>
          </div>
        )}

        <div className="detail--row">
          <FaCalendar className="icon" />
          <div className="detail--content">
            <span className="label">Created</span>
            <span className="value">{formatDate(order.createdAt || order.created_at)}</span>
          </div>
        </div>
      </div>

      <div className="order--footer">
        <div className="price--info">
          <span className="price--label">Total</span>
          <span className="price--value">
            ₦{(order.deliveryFee || order.delivery_fee || 0).toFixed(2)}
          </span>
        </div>
        {(order.paymentStatus || order.payment_status) && (
          <div className={`payment--status ${(order.paymentStatus || order.payment_status).toLowerCase()}`}>
            {(order.paymentStatus || order.payment_status) === 'PAID' || (order.paymentStatus || order.payment_status) === 'paid' ? 'Paid' : 'Pending'}
          </div>
        )}
      </div>
    </Container>
  );
};

export default OrderListItem;
